<template>
  <div id="publication-dashboard--configuration">
    <h3 is="sui-header">
      <i class="cog icon"></i>
      {{ $t('Configuration') }}
    </h3>
    <sui-divider />
    <tree-view :data="publicationConfig" :options="{maxDepth: 10}" ></tree-view>
    <sui-dimmer :active="loading" inverted>
      <sui-loader />
    </sui-dimmer>
  </div>
</template>

<script>

export default {
  name: 'configuration',
  props: ['dataRequested', 'publicationConfig'],
  data() {
    return {
      loading: true,
    };
  },
  updated() {
    this.removeLoader();
  },
  mounted() {
    this.removeLoader();
  },
  methods: {
    removeLoader() {
      if (this.dataRequested) {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">

</style>
